import {
    Component,
    ViewEncapsulation,
    Input,
    Output,
    ContentChildren,
    QueryList,
    OnDestroy,
    OnInit,
    DestroyRef, inject
} from '@angular/core';
import { IconMapper } from '../helpers/icon-mapper';
import { Subject, Subscription } from 'rxjs';
import { Router, NavigationEnd, NavigationCancel } from '@angular/router';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'cfa-tab',
    template: '<ng-content></ng-content>',
    encapsulation: ViewEncapsulation.None,
})
// tslint:disable-next-line:component-class-suffix
export class CfaTab extends IconMapper implements OnInit, OnDestroy {
    @Input() label: string;
    @Input() disabled = false;
    @Input() routerLink: string;

    @Output() selected: Subject<void> = new Subject();

    @ContentChildren(CfaTab) set setTabs(childTabs: QueryList<CfaTab>) {
        this.cTSubs.forEach(c => c.unsubscribe());
        this.cTSubs = [];

        if (childTabs) {
            this.childTabs = childTabs.toArray().filter(cTab => cTab !== this);
            this.childTabs.forEach(cTab => {
                if (cTab.selected.observers.length === 0) {
                    const cTSub = cTab.selected.subscribe(() => {
                        this.childTabSelected.next(cTab);
                    });
                    this.cTSubs.push(cTSub);
                }
                this.childTabInit.next();
            });
            this.checkActive(this.router.url);
        } else {
            this.childTabs = [];
        }
    }

    public active = false;
    public expanded = false;
    public childTabs: CfaTab[] = [];
    public childTabSelected: Subject<CfaTab> = new Subject<CfaTab>();
    public childTabInit: Subject<void> = new Subject();
    private cTSubs: Subscription[] = [];

    private readonly destroyRef: DestroyRef = inject(DestroyRef);


    constructor(private router: Router) {
        super();

        this.router.events
            .pipe(
                takeUntilDestroyed(this.destroyRef)
            )
            .subscribe(ev => {
            if (ev instanceof NavigationEnd || ev instanceof NavigationCancel) {
                this.checkActive(this.router.url);
            }
        });
    }

    public checkActive(currRoute: string) {
        this.active = currRoute.startsWith(this.routerLink);
    }

    ngOnInit() {
        this.checkActive(this.router.url);
    }

    ngOnDestroy() {
        this.cTSubs?.forEach(c => c.unsubscribe());
    }
}
